import { Building2, X } from 'lucide-react';
import React from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export interface ScreeningProvider {
  id: string;
  name: string;
}

interface ScreeningProviderRowProps {
  provider: ScreeningProvider;
  onRemove: (id: string) => void;
  isNew?: boolean;
}

export const ScreeningProviderRow: React.FC<ScreeningProviderRowProps> = ({
  provider,
  onRemove,
  isNew = false,
}) => {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-2 px-2 py-1.5 bg-zinc-50 rounded border border-zinc-200',
        'transition-all duration-300 ease-out',
        isNew && 'animate-in fade-in slide-in-from-top-2',
      )}
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <Building2 className="h-3.5 w-3.5 text-zinc-400 flex-shrink-0" />
        <span className="text-xs text-zinc-700 truncate">{provider.name}</span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        className="h-5 w-5 p-0 hover:bg-zinc-200"
        onClick={() => onRemove(provider.id)}
      >
        <X className="h-3 w-3 text-zinc-500" />
      </Button>
    </div>
  );
};
